import styled from 'styled-components';
import React from 'react';
import { capitalizeFirstLetter } from '../../helpers/CapitalizeFirstLetter';

const Status = styled.div<{ type: string }>`
    display: flex;
    padding: 4px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: ${(props) =>
        props.type === 'active' ? props.theme['Accent/on-accent'] : props.theme['Content/primary']};

    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;

    background: ${(props) => {
        switch (props.type) {
            case 'active':
                return 'linear-gradient(to right, #E5FD52, #7CEAD2)';
            case 'pending':
                return props.theme['Status/warning/bg'];
            case 'completed':
                return props.theme['Status/success/bg'];
            case 'canceled':
                return props.theme['Status/neutral/bg'];
            case 'refunded':
                return props.theme['Categorical/7/bg'];
            default:
                return props.theme['Status/neutral/bg'];
        }
    }};
`;

const StatusDot = styled.div<{ type: string }>`
    width: 8px;
    height: 8px;
    border-radius: 180px;
    background: ${(props) => {
        switch (props.type) {
            case 'active':
                return '#47ECD1';
            case 'pending':
                return '#D1AF57';
            case 'completed':
                return '#5E9767';
            case 'canceled':
                return '#7B869E';
            case 'refunded':
                return '#F2683A';
            default:
                return '#7B869E';
        }
    }};
`;

interface PaymentInstructionStatusProps {
    status: string;
    isNeedDot?: boolean;
}

const PaymentInstructionStatus = ({ status, isNeedDot }: PaymentInstructionStatusProps) => {
    return (
        <Status type={status}>
            {isNeedDot && <StatusDot type={status} />}
            {capitalizeFirstLetter(status)}
        </Status>
    );
};

export default PaymentInstructionStatus;
